import { defineComponent as _defineComponent } from 'vue'
import IconButton from '@white-label-icon/icon-button';
import IconCheck from '@white-label-icon/icon-check';

import type { TravelInsuranceQuoteDetails } from '@white-label-types/travel-insurance';
import { useContentPreloader } from '@white-label-helper/shared-composables';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-travel-insurance-documents-addons',
  props: {
    addons: { default: () => [] },
    documents: { default: () => [] },
    travellers: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { addons: TravelInsuranceQuoteDetails['addOns'], documents: TravelInsuranceQuoteDetails['documents'], travellers: TravelInsuranceQuoteDetails['travellers'] };



const { contentPreloaderEnabled } = useContentPreloader();

const openLink = (url: string) => {
  window.open(url, '_blank');
}

return { __sfc: true,props, contentPreloaderEnabled, openLink, IconButton, IconCheck }
}

})